export default __webpack_public_path__ + "static/media/checkmark.41f7a559.svg";